module.exports = __webpack_public_path__ + "static/media/icon_download_white.8d7abebc.svg";